import styled from 'styled-components';
import { TbChevronDown } from 'react-icons/tb';
import { Popover } from 'react-tiny-popover';
import { useMemo, useState } from 'react';
import SearchInput from '../SearchInput';
import Checkbox from '../../../../components/Checkbox';
export function Select({ options = [], value = [], onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [term, setTerm] = useState('');
  const onClose = () => {
    setIsOpen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const onSelect = item => {
    if (value.includes(item.id)) {
      onChange(value.filter(id => id !== item.id));
    } else {
      onChange([...value, item.id]);
    }
  };

  const label = useMemo(() => {
    if (value.length > 1) {
      return `${value.length} Projects`;
    }

    if (value.length === 1) return '1 Project';
  }, [value]);

  const filteredOptions = useMemo(() => {
    if (term) return options.filter(item => item.name.toLowerCase().includes(term.toLowerCase()));
    return options;
  }, [options, term]);

  return (
    <Popover
      isOpen={isOpen}
      onClickOutside={onClose}
      positions={['bottom']}
      padding={5}
      content={
        <MenuStyle>
          <SearchInput value={term} onChange={value => setTerm(value)} />
          <div className="items">
            {filteredOptions.map(item => (
              <div className="item" key={item.id}>
                <Checkbox onChange={() => onSelect(item)} checked={value.includes(item.id)} />
                {item.name}
              </div>
            ))}
          </div>
        </MenuStyle>
      }
    >
      <SelectStyle onClick={onOpen}>
        <p className={value.length > 0 && 'withValue'}>
          {value.length > 0 ? label : 'Select Project'}
        </p>
        <TbChevronDown color="#868E96" fontSize="16px" />
      </SelectStyle>
    </Popover>
  );
}

const MenuStyle = styled.div`
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  background: #fff;
  width: 274px;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  .items {
    margin-top: 8px;
    height: 400px;
    overflow: auto;
    .item {
      padding: 8px;
      display: flex;
      gap: 8px;
      align-items: center;
      color: #101113;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }
`;

const SelectStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 8px 12px;
  p {
    color: #adb5bd;
    font-size: 14px;
    line-height: 20px;
    &.withValue {
      color: #000;
    }
  }
`;
